// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Box, Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
// Components, Layouts, Pages
import { BaseInput } from '~/components/common';
// Others
import { IFormOrder } from '~/utils/interface/order';
// Styles, images, icons
import styles from './NotesOrderForm.module.scss';
import { icons } from '~/assets';

type Props = {};

const cx = classNames.bind(styles);

const NotesOrderForm = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/order']);

  const {
    control,
    formState: {},
  } = useFormContext<IFormOrder>();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo

  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box id='notesOrderFormComponent' className={cx('container')}>
      <Grid2 container spacing={'10px'}>
        <Grid2 size={6}>
          <Controller
            control={control}
            name={'internalNote'}
            render={({ field: { value, onChange } }) => (
              <BaseInput
                gap={'17px'}
                styleTypeLabel='title'
                iconLabel={icons.commonIconNote}
                multiline
                height={'auto'}
                rows={5}
                label={t('form_orders_label_internal_notes')}
                value={value}
                onChange={onChange}
              />
            )}
          />
        </Grid2>
        <Grid2 size={6}>
          <Controller
            control={control}
            name={'externalNote'}
            render={({ field: { value, onChange } }) => (
              <BaseInput
                gap={'17px'}
                styleTypeLabel='title'
                iconLabel={icons.commonIconNote}
                multiline
                height={'auto'}
                rows={5}
                label={t('form_orders_label_external_notes')}
                value={value}
                onChange={onChange}
              />
            )}
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default NotesOrderForm;
